import React from 'react'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'components/Tooltip'

import InfoIcon from 'assets/icons/info-icon16px'

import { TextArea, Label, TextAreaContainer, TextAreaDescription, TextAreaError, TextAreaCounter } from './style'

const tooltipXOffset = 0
const tooltipYOffset = 16
const Textarea = ({
  field,
  value = '',
  label,
  onChange,
  onBlur,
  onClick,
  type = 'text',
  placeholder = '',
  error,
  height,
  dataTest,
  disabled,
  padding,
  description,
  border,
  boxShadow,
  marginBottom,
  resize,
  infoTooltip,
  zIndex,
  background,
  maxHeight,
  marginTopError = '16px',
  hyper,
  textForLink,
  isOptional = false,
    maxLength,
  showCharCount = false,
}) => {
    const remaining = maxLength ? maxLength - value.length : 0
  return (
    <div data-testid='test-textarea' style={{ height: '100%' }}>
      {label && (
        <div style={{ marginBottom: '16px' }}>
          {React.isValidElement(label)
            ? label
            : label && (
              <Label data-test={`label-${dataTest}`} htmlFor={`input-${field}`}>
                <section style={{ display: 'flex', alignItems: 'center' }}>
                  <FormattedMessage id={label} />
                  {infoTooltip && (
                    <Tooltip
                      style={{ zIndex: 1000 }}
                      zIndex={zIndex}
                      placement="bottom"
                      trigger={['hover']}
                      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                      overlay={{ label: label, infoTooltip: infoTooltip }}
                      hyper={hyper}
                      textForLink={textForLink}
                    >
                      <div>
                        <InfoIcon />
                      </div>
                    </Tooltip>
                  )}
                </section>
                <span>{isOptional && <FormattedMessage id="optional" />}</span>
              </Label>
            )}
        </div>
      )}
      <TextAreaContainer disabled={disabled} style={{ position: 'relative', boxShadow: `${boxShadow}`, border: `${border}`, marginBottom: `${marginBottom}`, background: `${background}`, padding: `${padding}` }} error={error && error.field === field}>
        <FormattedMessage id={placeholder}>
          {(placeHolder) => {
            return (
              <TextArea
                id={`input-${field}`}
                type={type}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeHolder}
                height={height}
                data-test={dataTest}
                disabled={disabled}
                resize={resize}
                onClick={onClick}
                background={background}
                maxHeight={maxHeight}
                maxLength={maxLength}
              />
            )
          }}
        </FormattedMessage>
        {description && (
          <TextAreaDescription>
            <FormattedMessage id={description} />
          </TextAreaDescription>
        )}

          {showCharCount && maxLength && (
          <div
            style={{
              position: 'absolute',
              bottom: '6px',
              left: '19px',
              fontSize: '13px',
              color: remaining <= 0 ? '#E11900' : 'rgba(32, 32, 32, 0.6)',
            }}
          >
            {maxLength - value.length} <FormattedMessage id="Characters" />
          </div>
        )}

      </TextAreaContainer>
      {error && error.field === field && (
        <TextAreaError marginTopError={marginTopError} data-test="validation-error-message">
          <FormattedMessage id={error.error} />
        </TextAreaError>
      )}
    </div>
  )
}

export default Textarea
